<form [formGroup]="form" (change)="update()">
  <div class="field" *ngFor="let control of languages">
    <label class="field-label" [for]="'lang-input-' + control.value">
      {{ control.label | translate | uppercase }}
    </label>
    <ng-container *ngIf="inputType === 'input'; else textArea">
      <input
        [id]="'lang-input-' + control.value"
        class="ts-input"
        type="text"
        [formControlName]="control.value"
      />
    </ng-container>
    <ng-template #textArea>
      <textarea
        [id]="'lang-input-' + control.value"
        class="ts-textarea"
        cdkTextareaAutosize
        [formControlName]="control.value"
      ></textarea>
    </ng-template>
  </div>
</form>
